<template>
  <v-app>
    <slot name="snackbar-content" />
    <layout-toolbar />
    <layout-drawer />
    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LayoutDrawer from '@/components/layout/LayoutDrawer';
import LayoutToolbar from '@/components/layout/LayoutToolbar';

export default {
  name: 'MainLayout',
  components: {
    LayoutDrawer,
    LayoutToolbar
  }
}
</script>